import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

interface IContainerProps {
  index: number;
}

export const Container = styled(motion.div)<IContainerProps>`
  display: flex;
  padding: 0.5rem;
  margin: 0 auto;

  @media screen and ${min('largeTablet')} {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    padding: 1rem;
  }
`;

export const Content = styled.div`
  border: 3px solid;
  padding: 1rem;

  @media screen and ${min('largeTablet')} {
    border: 1px solid;
    padding: 2rem;
  }
  h3 {
    text-align: left;
  }
`;

export const DescriptionContainer = styled.div`
  font-size: 0.875rem;
  line-height: 150%;
  margin-top: 0.625rem;

  @media screen and ${min('tablet')} {
    font-size: 1rem;
  }
  @media screen and ${min('desktop')} {
    font-size: 1.125rem;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  .feature-back-image,
  .feature-front-image {
    display: block;
    max-width: 100%;
  }

  .feature-front-image {
    position: absolute;
    left: 0;
    bottom: 0;
    max-height: 110%;
  }
`;

export const IconContainer = styled.div`
  margin: 1rem 0 0.625rem;

  svg {
    path {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`;
